import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EcondosFilter } from '@api/util/filter';
import { EcondosQuery } from '@api/model/query';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-filter-page',
  templateUrl: './modal-filter.component.html',
  styleUrls: ['./modal-filter.component.scss']
})
export class ModalFilterComponent implements OnInit {
  initialFilters: EcondosFilter[] = [];
  initialQuery: EcondosQuery = {};

  filterForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private fb: UntypedFormBuilder,
    public nzModalRef: NzModalRef,
    @Inject(NZ_MODAL_DATA) data: { initialFilters: EcondosFilter[]; initialQuery: EcondosQuery }
  ) {
    this.initialFilters = data.initialFilters;
    this.initialQuery = data.initialQuery;
  }

  ngOnInit(): void {
    const formControls = this.initialFilters.reduce(
      (acc, cur) => {
        if (cur.name) {
          acc[cur.name] = [this.initialQuery[cur.name] ?? ''];
        }
        return acc;
      },
      {} as { [key: string]: any }
    );

    this.filterForm = this.fb.group(formControls);

    // Preencher com valores iniciais se existirem
    this.initialFilters.forEach(f => {
      if (f.name && f.value !== undefined) {
        this.filterForm.get(f.name)?.setValue(f.value);
      }
    });
  }

  returnQuery(): void {
    const query = this.buildQuery({ ...this.initialQuery }, this.filterForm.value);
    const filters = this.setFiltersValues(this.initialFilters, this.filterForm.value);
    this.nzModalRef.close({ query, filters });
  }

  buildQuery(query: EcondosQuery, formValues: any): EcondosQuery {
    Object.keys(formValues).forEach(key => {
      if (formValues[key] !== '' && formValues[key] !== null && formValues[key] !== undefined) {
        query[key] = formValues[key];
      }
    });
    return query;
  }

  setFiltersValues(filters: EcondosFilter[], formValues: any): EcondosFilter[] {
    return filters.map(f => ({
      ...f,
      value: f.name ? formValues[f.name] : undefined
    }));
  }
}
